import React from 'react';
import {images} from '../../images/images';

export const SoulClap = () => {

	return (
		<main className='soulClapContainer'>
			<figure className='profileHeader'>
				<div className='darkOverlay' />
				<h1>Artist:<br/>Soul Clap</h1>
				<img className='profileCoverImage' src={images.soulClap.cover} alt='Soul CLap Cover'/>
				<ul>
					<li>Date Establised /<br />2001</li>
					<li>Location /<br />Boston, Massachusetts</li>
					<li>Genres /<br />Funk, Disco, House</li>
					<li>On the Internet /<br /><a href='https://www.facebook.com/soulclap/'>Facebook</a> / <a href='http://soulclap.us/album/'>Website</a> / <a href='https://soundcloud.com/soulclap'>Soundcloud</a> /</li>
				</ul>
			</figure>
			<article className='profileBody'>
				<h2>"Lonely C & Bamboozle is on a mission to change one dance floor at a time"</h2>
				<br/>
				<br/>
				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
				tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
				quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
				consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
				cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
				proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
				<br/>
				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
				tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
				quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
				consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
				cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
				proident, sunt in culpa qui officia deserunt mollit anim id est laborum. Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
				tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
				quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
				consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
				cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
				proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
				<br/>
				<p>Lorem ipsum dolor sit amet, consectetur adipisicing elit, sed do eiusmod
				tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam,
				quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo
				consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse
				cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non
				proident, sunt in culpa qui officia deserunt mollit anim id est laborum.</p>
				<br/>
				<br/>
				<br/>
			
				<br/>
				<br/>
				<br/>
			</article>
		</main>
		)
}